module.exports = __webpack_public_path__ + "img/centered-logo-nav-lincoln.11166c9b.png";